import { withClassName } from 'lp-hoc'

const FormBlock = withClassName('form-block')('div')

export default FormBlock
